import { editableElement } from '~components/Edition/Editables/EditableElement/EditableElement'
import { editableText } from '~components/Edition/Editables/EditableText/EditableText'
import { generateLoremIpsum } from '~utils/misc'
import { TCitationTextSection } from './CitationTextSection.types'

const CitationTextSectionDefaultData: TCitationTextSection = {
	data: {
		items: [
			{
				title: editableElement(generateLoremIpsum('normal')),
				text: editableText('— Citer la source')
			},
			{
				title: editableElement(generateLoremIpsum('normal')),
				text: editableText('— Citer la source')
			}
		]
	},
	params: {
		backgroundImage: '',
		sectionHeight: 'medium',
		sectionWidth: 'medium',
		alignText: 'center',
		alignVertical: 'center',
		alignHorizontal: 'center'
	}
}

export default CitationTextSectionDefaultData
